import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${props => props.theme.fonts.body};
    background-color: ${props => props.theme.colors.cream};
    color: ${props => props.theme.colors.black};
    line-height: 1.6;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.fonts.heading};
    line-height: 1.2;
    margin: 0 0 ${props => props.theme.spacing.md};
  }

  p {
    margin: 0 0 ${props => props.theme.spacing.md};
  }

  a {
    color: inherit;
    text-decoration: none;
    transition: all ${props => props.theme.transitions.default};
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
    font-family: inherit;
    color: inherit;
    padding: 0;
    transition: all ${props => props.theme.transitions.default};

    &:focus {
      outline: none;
    }
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  ul, ol {
    list-style: none;
  }

  input, textarea {
    font-family: inherit;
    border: none;
    outline: none;
    background: none;
    color: inherit;
  }

  ::selection {
    background-color: ${props => props.theme.colors.wood};
    color: ${props => props.theme.colors.cream};
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.cream};
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.wood};
    border-radius: ${props => props.theme.borderRadius.small};
    
    &:hover {
      background: ${props => props.theme.colors.woodDark};
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    html {
      font-size: 14px;
    }
  }
`;

export default GlobalStyle;
